import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getBioDetail } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import PersonInfo from "components/common/participants/PersonInfo"
import BioAnchors from "components/common/participants/BioAnchors"
import BioData from "components/common/participants/BioData"
import { usePreparePayLoad } from 'components/common/ocs-custom-events/helpers';
import FireOnContentLoadOCS from 'components/general/FireOnContentLoadOCS';
import { useScrollToTop } from 'helpers/utils';

export default function Official() {
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const payloadParams = usePreparePayLoad()
    useScrollToTop();


    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['bioDetail', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_code']],
            queryFn: getBioDetail,
            enabled: true
            // notifyOnChangeProps: [id] | "tracked"
        });

    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.person) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    return (
        <>
            <FireOnContentLoadOCS params={params} data={data} payloadParams={payloadParams} />
            <div className='mirs-page-container'>
                <div className="wrsBiosDetail__panel">
                    <div className="bios-personalinfo">
                        <PersonInfo data={data} />
                        <BioAnchors data={data} />
                    </div>

                    <BioData data={data} />
                </div>
            </div>
        </>
    );
};

